
  export default {
    data() {
      window.wf ??= {};
      let d = window.wf.RespondingToPromotion;
      d.promoCodes ??= {};
      d.errorMessageTemplate ??= '';
      d.errorMessage ??= '';
      d.tabActive = false;
      d.enteredPromoCode = '';
      d.showError = false;
      return d;
    },
    methods: {
      toggleTab() {
        this.tabActive = !this.tabActive;
      },
      handlePromoCode() {
        this.showError = false;
        if (this.enteredPromoCode != '') {
          var activePromo = this.promoCodes.filter(x => x.promo == this.enteredPromoCode);
          if (activePromo.length > 0) {
            var targetUrl = activePromo[0].url;
            if (targetUrl.indexOf("?") > -1) {
              targetUrl += "&promo=" + activePromo[0].promo;
            } else {
              targetUrl += "?promo=" + activePromo[0].promo;
            }
            window.location.href = targetUrl;
          } else {
            this.errorMessage = this.errorMessageTemplate.replace('{0}', this.enteredPromoCode);
            this.showError = true;
          }
        }
      }
    },
    computed: {
      classObject: function() {
        return {
          'responding-promotion': true,
          'active': this.tabActive
        };
      }
    }
  }
